import { useQuery } from '@apollo/client';
import { useRole } from 'app/domains/users/hooks/useRole';
import { query } from './query';
import { shouldDisplayUpgradeButton } from '../utils';
export function useDisplayUpgrade() {
    const role = useRole();
    const { data } = useQuery(query);
    const { company } = data || {};
    const displayForUser = role.can('manage:settings');
    const displayForCompany = shouldDisplayUpgradeButton(company === null || company === void 0 ? void 0 : company.plans);
    return displayForUser && displayForCompany;
}
